/*
 * Header-Navigation: Active/Current-Markierung per JS statt server-seitig.
 *
 * Grund: `Neos.Neos:MenuItems` mit `calculateItemStates = true` berechnet den
 * State pro aufgerufener Seite, wodurch der Fusion-Content-Cache für die
 * komplette (teure, rekursive) Navigations-Query nicht seitenübergreifend
 * wiederverwendet werden kann. Jedes <li> trägt stattdessen `data-nav-path`
 * (der URI des zugehörigen Nodes aus Nav.fusion) und bekommt hier anhand der
 * aktuellen URL die Klassen `current` / `active` gesetzt.
 *
 * `current` wird nur per exaktem Pfad-Treffer vergeben. `active` (Vorfahre
 * der aktuellen Seite) wird per DOM-Bubble-up ermittelt statt per
 * Pfad-Präfix-Vergleich: Level-1-Einträge vom Typ "FirstLevelShorcut" sind
 * reine Dropdown-Trigger ohne echte eigene Seite – ihr `uri` kann auf ein
 * Shortcut-Ziel (z. B. die Startseite "/") zeigen, das nichts mit ihrer
 * Position im Seitenbaum zu tun hat. Ein Pfad-Präfix-Vergleich würde solche
 * Einträge fälschlich matchen; DOM-Ancestry spiegelt dagegen immer die
 * echte Node-Hierarchie wider (die Menüstruktur wird rekursiv aus dem
 * Content-Graph aufgebaut).
 */

document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('.header')
  if (!header) return

  const items = [...header.querySelectorAll('[data-nav-path]')]
  if (!items.length) return

  // Resolves a (possibly relative) path to a same-origin pathname, or null
  // for unparsable/cross-origin URLs (external links, other subdomains) so
  // they can never accidentally match the current page.
  const resolveSameOriginPath = (path) => {
    if (!path) return null
    try {
      const url = new URL(path, window.location.origin)
      if (url.origin !== window.location.origin) return null
      return url.pathname.replace(/\/+$/, '') || '/'
    } catch (e) {
      return null
    }
  }

  const currentPath = resolveSameOriginPath(window.location.pathname)
  if (!currentPath) return

  // Exact match marks the menu item(s) representing the current page itself.
  // Shortcut-only trigger items (no real page of their own) never match here.
  items.forEach((li) => {
    if (li.dataset.navShortcut === 'true') return
    if (resolveSameOriginPath(li.dataset.navPath) === currentPath) {
      li.classList.add('current')
    }
  })

  // Bubble up: every ancestor menu item of a current/active item is itself
  // "active", regardless of what its own uri resolves to.
  header.querySelectorAll('.header-nav-list li.current, .header-nav-list li.active').forEach((li) => {
    let parent = li.parentElement && li.parentElement.closest('[data-nav-path]')
    while (parent) {
      if (!parent.classList.contains('current')) parent.classList.add('active')
      parent = parent.parentElement && parent.parentElement.closest('[data-nav-path]')
    }
  })
})
